export default function SkeletonInput() {
    return (<span className="placeholder placeholder-input placeholder-lg col-12" />);
}